<template>
    <div class="co2">
        <p>
            Gas in Kalkwasser (Calciumhydroxid) einleiten
            <br />
            Bildung eines weißen Niederschlags (CaCO<sub>3</sub>)
            <br />
            Ca(OH)<sub>2</sub> + CO<sub>2</sub> → CaCO<sub>3</sub> +
            H<sub>2</sub>O
            <br />
            Alternative: Gas einleiten in Bariumhydroxid-Lösung:
            <br />
            CO<sub>2</sub> + Ba(OH)<sub>2</sub> → BaCO<sub>3</sub> +
            H<sub>2</sub>O
        </p>
    </div>
</template>

<script>
export default {
    name: 'co2',
};
</script>
